import styled from '@emotion/styled'
import { breakpoint, calcRem, fonts, metrics } from '../../__styling'
import { IconChevronRightTN } from '../../icons/IconChevronRightTN/IconChevronRightTN'
import { tokens } from '@news-mono/design-tokens'

const { sm, m2l, lg, xxl, xxxxl } = metrics.thenightly.margins

export const StyledBackNav = styled('div')<{ showOnLargeScreen?: boolean }>(
    ({ showOnLargeScreen = true }) => ({
        display: 'flex',
        span: {
            fontWeight: 400,
            lineHeight: '150%',
            cursor: 'pointer',
        },
        svg: { cursor: 'pointer' },
        marginBottom: calcRem(sm),
        width: 'fit-content',

        [breakpoint('sm')]: {
            display: showOnLargeScreen ? 'flex' : 'none',
        },
    }),
)

export const StyledIconChevron = styled(IconChevronRightTN)<{
    direction?: 'left' | 'right'
}>(({ direction = 'right' }) => ({
    height: calcRem(m2l),
    width: calcRem(m2l),
    transform: direction === 'left' ? `rotateY(180deg)` : undefined,
}))

export const StyledMainScreen = styled('div')<{ show?: boolean }>(
    ({ show }) => ({
        width: '100%',
        display: show ? 'block' : 'none',
        padding: calcRem(xxl, 0, 0, 0),
        fontFamily: fonts.thenightly.sansSerif,

        h2: {
            fontSize: calcRem(40),
            fontWeight: 700,
            lineHeight: calcRem(48),
            margin: calcRem(0, 0, 0, 0),

            '&.bottom-header': {
                marginBottom: lg,
            },
        },
        h4: {
            color: tokens.thenightly.colors.text.tertiary,
            fontSize: calcRem(16),
            fontWeight: 400,
            lineHeight: calcRem(24),
            margin: 0,

            '&.bottom-header': {
                marginTop: sm,
                marginBottom: lg,
            },
        },

        [breakpoint('sm')]: {
            display: 'block',
            padding: calcRem(64, 0, 64, m2l),
            h2: {
                fontSize: calcRem(45),
            },
        },

        [breakpoint('lg')]: {
            padding: calcRem(xxxxl, 0, xxxxl, m2l),
            h2: {
                fontSize: calcRem(51),
                lineHeight: calcRem(56),
            },
        },
    }),
)

export const StyledButtonGroup = styled('div')(({}) => ({
    display: 'flex',
    justifyContent: 'end',
}))
